import { Cube } from "../../state/types";
import { Section } from "./Section";
import { Height } from "./soil/Height";
import { Soil } from "./soil/Soil";
import { A } from "./util";

const description = (
  <>
    <div>
      Voor de grondsoorten wordt de
      <A href="https://www.wur.nl/nl/show/grondsoortenkaart.htm">
        grondsoortenkaart van WUR/Alterra
      </A>{" "}
      en de{" "}
      <A href="https://basisregistratieondergrond.nl/inhoud-bro/registratieobjecten/modellen/bodemkaart-sgm/">
        Basisregistratie Ondergrond
      </A>{" "}
      gebruikt.
    </div>
    {/* <div>Geomorfologie beschrijft de totstandkoming van de vorm/structuur en de processen rondom het aardoppervlak.</div> */}
    <div>
      Grondgebruik beschrijft het gebruik op basis van{" "}
      <A href="https://lgn.nl/">Landelijk Grondgebruik Nederland</A>.
    </div>
    <div>
      De hoogtekaart is gebaseerd op de <A href="https://ahn.nl/">Algemene Hoogtekaart Nederland</A>
      .
    </div>
    Archeologie behandelt informatie rondom{" "}
    <A href="https://www.cultureelerfgoed.nl/">cultureel erfgoed</A>. De Archeologische (
    <A href="https://www.cultureelerfgoed.nl/onderwerpen/archeologische-rijksmonumenten">rijks-</A>)
    <A href="https://www.cultureelerfgoed.nl/onderwerpen/archeologische-monumentenzorg">
      monumenten
    </A>{" "}
    worden bij elk perceel getoond. De
    <A href="https://www.cultureelerfgoed.nl/onderwerpen/b/bronnen-en-kaarten/overzicht/archeologie-in-nederland-amk-en-ikaw">
      Indicatieve Kaart Archeologische Waarden (IKAW)
    </A>
    betreft een grof raster en wordt niet meer bijgewerkt. Voor Ontplofbare Oorlogsresten (OO) wordt
    een grofmazige expert-kaart gebruikt. De Links naar voornamelijk gemeentelijke websites geven
    meer informatie.
  </>
);

import { DKVColorBoxLabel, KVColorBoxLabel } from "../../components/ColorBox";
import { AdministrativeData } from "../../state/types";
import { Info, ITooltip, Links } from "./util";

const mapping = {
  municipality: "Gemeente",
  archeology: "Archeologie",
  culture: "Cultuurhistorie",
  viewer: "Applicatie",
  map: "Kaart",
};

const Monuments = ({ data }) => (
  <ITooltip
    content={
      <div>
        {data.description}
        <br />
        <h4 className="font-bold pt-1">Meer</h4>
        <span dangerouslySetInnerHTML={{ __html: data.html }} />
      </div>
    }
  >
    {" "}
    {data.name}
  </ITooltip>
);

const SMonuments = ({ data }) => <A href={data.url}>Informatie</A>;

const AWKLinks = ({ archLinks }: { archLinks: AdministrativeData }) => {
  const data = archLinks?.data;
  if (!data) return null;
  return (
    <Links>
      {Object.entries(mapping).map(([key, value]) =>
        data[key] ? (
          <A key={key} href={data[key]}>
            {value}
          </A>
        ) : null
      )}
    </Links>
  );
};

const AWK = ({ field }: { field: Cube }) => {
  const { archMonuments, archStateMonuments } = field?.data || {};
  const ikaw = field?.rast?.NLIKAW;
  const oo = field?.rast?.OOExpl;
  if (!(archMonuments || archStateMonuments || ikaw)) return null;
  return (
    <Info as="dl">
      <KVColorBoxLabel k="Archeologie" elem={ikaw} />
      <DKVColorBoxLabel k="Archeologisch monument" elem={archMonuments} DataComponent={Monuments} />
      <DKVColorBoxLabel
        k="Archeologisch rijksmonument"
        elem={archStateMonuments}
        DataComponent={SMonuments}
      />
      <KVColorBoxLabel k="Exposieven (OO)" elem={oo} />
    </Info>
  );
};
export const SectionSoil = ({ field }: { field: Cube }) => (
  <Section name="soil" description={description}>
    <Soil field={field} />
    <Height field={field} />
    <AWK field={field} />
    <AWKLinks archLinks={field.administrative.archLinks} />
  </Section>
);
